/* ==========================================================================
   Pulse Theme — front-end behavior
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Image skeleton loaders --------------------------------- */
  function markLoaded(img) {
    var wrap = img.closest('.media-skel');
    if (wrap) wrap.classList.add('is-loaded');
    else img.style.opacity = 1;
  }
  function initSkeletons(root) {
    (root || document).querySelectorAll('.skel-img').forEach(function (img) {
      if (img.dataset.skelBound) return;
      img.dataset.skelBound = '1';
      if (img.complete && img.naturalWidth > 0) { markLoaded(img); return; }
      img.addEventListener('load', function () { markLoaded(img); }, { once: true });
      img.addEventListener('error', function () { markLoaded(img); }, { once: true });
    });
  }
  initSkeletons();
  window.PulseInitSkeletons = initSkeletons;

  /* ---------- Section skeleton overlays ------------------------------- */
  function initSectionSkels(root) {
    (root || document).querySelectorAll('[data-sec-host]').forEach(function (host) {
      if (host.dataset.secSkelBound) return;
      host.dataset.secSkelBound = '1';
      var skel = host.querySelector('[data-sec-skel]');
      if (!skel) return;
      var done = false;
      function ready() {
        if (done) return;
        done = true;
        host.classList.add('sec-ready');
        setTimeout(function () { if (skel.parentNode) skel.parentNode.removeChild(skel); }, 450);
      }
      var pending = [];
      var waitUrl = host.getAttribute('data-sec-wait');
      if (waitUrl) {
        var probe = new Image();
        probe.src = waitUrl;
        pending.push(probe);
      }
      host.querySelectorAll('img').forEach(function (im) {
        if (!im.closest('[data-sec-skel]')) pending.push(im);
      });
      pending = pending.filter(function (im) { return !(im.complete && im.naturalWidth > 0); });
      if (pending.length === 0) { ready(); return; }
      var left = pending.length;
      function step() { left -= 1; if (left <= 0) ready(); }
      pending.forEach(function (im) {
        im.addEventListener('load', step, { once: true });
        im.addEventListener('error', step, { once: true });
      });
      setTimeout(ready, 2000);
    });
  }
  initSectionSkels();
  document.addEventListener('shopify:section:load', function (e) { initSectionSkels(e.target); });

  const money = (cents) => {
    const format = (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';
    const value = cents == null ? 0 : cents;
    const build = (precision, thousands, decimal) => {
      const n = (value / 100.0).toFixed(precision);
      const parts = n.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, name) => {
      switch (name) {
        case 'amount': return build(2, ',', '.');
        case 'amount_no_decimals': return build(0, ',', '.');
        case 'amount_with_comma_separator': return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return build(0, '.', ',');
        case 'amount_with_space_separator': return build(2, ' ', '.');
        case 'amount_no_decimals_with_space_separator': return build(0, ' ', '.');
        case 'amount_with_apostrophe_separator': return build(2, "'", '.');
        default: return '';
      }
    });
  };

  /* ---------- Generic drawer toggling --------------------------------- */
  function syncTriggers(el, expanded) {
    if (!el || !el.id) return;
    document.querySelectorAll('[data-drawer-open="' + el.id + '"]').forEach(function (t) {
      t.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
  function openDrawer(el) { if (el) { el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; syncTriggers(el, true); } }
  function closeDrawer(el) { if (el) { el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; syncTriggers(el, false); } }

  document.addEventListener('click', (e) => {
    const openTrigger = e.target.closest('[data-drawer-open]');
    if (openTrigger) {
      e.preventDefault();
      openDrawer(document.getElementById(openTrigger.getAttribute('data-drawer-open')));
    }
if (e.target.closest('[data-drawer-close]')) {
  const drawer = e.target.closest('[aria-hidden="false"]');
  closeDrawer(drawer);
}

    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      const m = document.getElementById('SearchModal');
      if (m) { m.hidden = false; const i = m.querySelector('input[type="search"]'); if (i) setTimeout(() => i.focus(), 50); }
    }
    if (e.target.closest('[data-search-close]')) {
      const m = document.getElementById('SearchModal');
      if (m) m.hidden = true;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('[aria-hidden="false"]').forEach(closeDrawer);
      const m = document.getElementById('SearchModal');
      if (m && !m.hidden) m.hidden = true;
    }
  });

  /* ---------- Cart API ------------------------------------------------- */
  const Cart = {
    async getState() {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return res.json();
    },
    async add(items) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw await res.json();
      return res.json();
    },
    async change(line, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      return res.json();
    }
  };
  window.PulseCart = Cart;

  const drawerEl = document.getElementById('CartDrawer');
  const threshold = drawerEl ? parseInt(drawerEl.getAttribute('data-free-shipping-threshold') || '0', 10) * 100 : 0;
  const showBar = drawerEl ? drawerEl.getAttribute('data-free-shipping-bar') === 'true' : false;

  function renderCart(state) {
    document.querySelectorAll('[data-cart-count]').forEach((b) => {
      b.textContent = state.item_count;
      b.style.display = state.item_count > 0 ? '' : 'none';
    });

    if (!drawerEl) return;
    const itemsEl = drawerEl.querySelector('[data-cart-items]');
    const footerEl = drawerEl.querySelector('[data-cart-footer]');

    if (state.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn" data-drawer-close>Continue shopping</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (footerEl) footerEl.style.display = '';

    itemsEl.innerHTML = state.items.map((item) => `
      <div class="cart-item" data-line-key="${item.key}">
        <a href="${item.url}">${item.image ? `<img src="${item.image.replace(/(\.[^.]+)$/, '_160x$1')}" alt="" width="72" height="72" loading="lazy">` : ''}</a>
        <div>
          <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__qty">
            <button type="button" data-qty-down aria-label="Decrease">&minus;</button>
            <input type="text" value="${item.quantity}" data-qty-input readonly>
            <button type="button" data-qty-up aria-label="Increase">&plus;</button>
          </div>
          <div><button type="button" class="cart-item__remove" data-line-remove>Remove</button></div>
        </div>
        <div class="cart-item__price">${money(item.final_line_price)}</div>
      </div>
    `).join('');

    if (footerEl) {
      let barHtml = '';
      if (showBar && threshold > 0) {
        const remaining = threshold - state.total_price;
        const pct = Math.min(100, (state.total_price / threshold) * 100);
        barHtml = `
          <div class="free-shipping-bar">
            <div class="free-shipping-bar__text">${remaining > 0 ? `Spend ${money(remaining)} more for free shipping!` : "You've unlocked free shipping! 🎉"}</div>
            <div class="free-shipping-bar__track"><div class="free-shipping-bar__fill" style="width:${pct}%"></div></div>
          </div>`;
      }
      footerEl.innerHTML = `
        ${barHtml}
        <div class="cart-drawer__subtotal"><span>Subtotal</span><span>${money(state.total_price)}</span></div>
        <p style="font-size:1.3rem;opacity:.6;text-align:center;">Taxes and shipping calculated at checkout</p>
        <a href="/checkout" class="btn btn--full">Check out</a>
        <a href="/cart" class="btn btn--secondary btn--full mt-2">View cart</a>`;
    }
  }

  async function refreshCart(open) {
    const state = await Cart.getState();
    renderCart(state);
    if (open) openDrawer(drawerEl);
  }

  // Quantity / remove inside drawer
  if (drawerEl) {
    drawerEl.addEventListener('click', async (e) => {
      const row = e.target.closest('[data-line-key]');
      if (!row) return;
      const key = row.getAttribute('data-line-key');
      const input = row.querySelector('[data-qty-input]');
      let qty = parseInt(input.value, 10);
      if (e.target.closest('[data-qty-up]')) qty += 1;
      else if (e.target.closest('[data-qty-down]')) qty = Math.max(0, qty - 1);
      else if (e.target.closest('[data-line-remove]')) qty = 0;
      else return;
      const cartState = await Cart.getState();
      const lineIndex = cartState.items.findIndex(item => item.key === key) + 1;
      if (lineIndex === 0) return;
      const state = await Cart.change(lineIndex, qty);
      renderCart(state);
    });
  }


  /* ---------- Add to cart forms (AJAX) -------------------------------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"], form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding...'; }
    try {
      const id = form.querySelector('[name="id"]').value;
      const qtyEl = form.querySelector('[name="quantity"]');
      const quantity = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      await Cart.add([{ id: parseInt(id, 10), quantity }]);
      await refreshCart(true);
      if (btn) btn.textContent = 'Added ✓';
    } catch (err) {
      if (btn) btn.textContent = (err && err.description) ? 'Unavailable' : 'Error';
      console.error('Cart error', err);
    } finally {
      setTimeout(() => { if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = original; } }, 1200);
    }
  });

  /* ---------- Quick add (single-variant or first variant) ------------- */
  document.addEventListener('click', async (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    const variantId = qa.getAttribute('data-quick-add');
    if (!variantId) return;
    const original = qa.textContent;
    qa.textContent = 'Adding...';
    try {
      await Cart.add([{ id: parseInt(variantId, 10), quantity: 1 }]);
      await refreshCart(true);
      qa.textContent = 'Added ✓';
    } catch (err) {
      qa.textContent = 'Error';
    } finally {
      setTimeout(() => { qa.textContent = original; }, 1200);
    }
  });

  /* ---------- Slideshow ------------------------------------------------ */
  document.querySelectorAll('[data-slideshow]').forEach((root) => {
    const track = root.querySelector('[data-slideshow-track]');
    const slides = Array.from(root.querySelectorAll('.slideshow__slide'));
    const dots = Array.from(root.querySelectorAll('[data-slide-dot]'));
    if (slides.length <= 1) return;
    let index = 0;
    const autoplay = root.getAttribute('data-autoplay') === 'true';
    const speed = parseInt(root.getAttribute('data-speed') || '6', 10) * 1000;
    let timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((d, di) => d.setAttribute('aria-current', di === index ? 'true' : 'false'));
    }
    root.querySelector('[data-slide-next]')?.addEventListener('click', () => { go(index + 1); reset(); });
    root.querySelector('[data-slide-prev]')?.addEventListener('click', () => { go(index - 1); reset(); });
    dots.forEach((d, di) => d.addEventListener('click', () => { go(di); reset(); }));

    function reset() { if (autoplay) { clearInterval(timer); timer = setInterval(() => go(index + 1), speed); } }
    reset();
  });

  /* ---------- Product variant selection ------------------------------- */
  document.querySelectorAll('[data-product-form]').forEach((root) => {
    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    let product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const idInput = root.querySelector('[name="id"]');
    const priceEl = root.querySelector('[data-product-price]');
    const submitBtn = root.querySelector('[data-add-button]');

    function getSelectedOptions() {
      return Array.from(root.querySelectorAll('[data-option-index]')).reduce((acc, el) => {
        if (el.type === 'radio') { if (el.checked) acc[parseInt(el.getAttribute('data-option-index'), 10)] = el.value; }
        else acc[parseInt(el.getAttribute('data-option-index'), 10)] = el.value;
        return acc;
      }, []);
    }

    function update() {
      const optionEls = root.querySelectorAll('[data-option-index]');
      const selected = getSelectedOptions();
      // No option pickers rendered (single-variant product) -> use the only variant
      const variant = optionEls.length === 0
        ? product.variants[0]
        : product.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      if (!variant) {
        if (submitBtn) { submitBtn.setAttribute('aria-disabled', 'true'); submitBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = `<span class="price__sale">${money(variant.price)}</span> <span class="price__compare">${money(variant.compare_at_price)}</span>`;
        } else {
          priceEl.innerHTML = `<span class="price__regular">${money(variant.price)}</span>`;
        }
      }
      if (submitBtn) {
        if (variant.available) { submitBtn.removeAttribute('aria-disabled'); submitBtn.textContent = 'Add to cart'; }
        else { submitBtn.setAttribute('aria-disabled', 'true'); submitBtn.textContent = 'Sold out'; }
      }
      // Show the variant's image in the gallery
      if (variant.featured_media_id) {
        const gallery = root.querySelector('[data-product-gallery]') || document.querySelector('[data-product-gallery]');
        if (gallery && gallery.galleryShowMedia) gallery.galleryShowMedia(variant.featured_media_id);
      }
      // Update URL
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
    root.querySelectorAll('[data-option-index]').forEach((el) => el.addEventListener('change', update));
    update();
  });

  /* ---------- Product gallery: thumb strip + swipe + arrows ----------- */
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main] img');
    const mainWrap = gallery.querySelector('[data-gallery-main]');
    const strip = gallery.querySelector('[data-thumbs-strip]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || thumbs.length === 0) return;
    let current = 0;

    function activate(i) {
      current = (i + thumbs.length) % thumbs.length;
      const t = thumbs[current];

      const bg = t.getAttribute('data-bg');
      if (mainWrap && bg) mainWrap.style.backgroundImage = 'url(' + bg + ')';
      main.style.opacity = '0';
      if (mainWrap) mainWrap.classList.add('is-swapping');

      const done = () => {
        main.style.opacity = '';
        if (mainWrap) mainWrap.classList.remove('is-swapping');
      };
      const srcset = t.getAttribute('data-srcset');
      if (srcset) main.setAttribute('srcset', srcset);
      else main.removeAttribute('srcset');
      main.src = t.getAttribute('data-full');
      if (main.complete && main.naturalWidth > 0) {
        done();
      } else {
        main.addEventListener('load', done, { once: true });
        main.addEventListener('error', done, { once: true });
      }

      thumbs.forEach((x, k) => x.setAttribute('aria-current', k === current ? 'true' : 'false'));
      if (t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => activate(i)));

    const prev = gallery.querySelector('[data-thumbs-prev]');
    const next = gallery.querySelector('[data-thumbs-next]');
    if (strip && prev && next) {
      const updateArrows = () => {
        const overflow = strip.scrollWidth > strip.clientWidth + 4;
        prev.hidden = !overflow;
        next.hidden = !overflow;
      };
      updateArrows();
      window.addEventListener('resize', updateArrows, { passive: true });
      prev.addEventListener('click', () => strip.scrollBy({ left: -strip.clientWidth * 0.7, behavior: 'smooth' }));
      next.addEventListener('click', () => strip.scrollBy({ left: strip.clientWidth * 0.7, behavior: 'smooth' }));
    }

    if (mainWrap && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      mainWrap.addEventListener('mouseenter', () => mainWrap.classList.add('is-zooming'));
      mainWrap.addEventListener('mouseleave', () => {
        mainWrap.classList.remove('is-zooming');
        main.style.transformOrigin = '';
      });
      mainWrap.addEventListener('mousemove', (e) => {
        const r = mainWrap.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        main.style.transformOrigin = x + '% ' + y + '%';
      });
    }

    if (mainWrap) {
      let startX = null;
      mainWrap.addEventListener('pointerdown', (e) => { startX = e.clientX; });
      mainWrap.addEventListener('pointerup', (e) => {
        if (startX === null) return;
        const dx = e.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) activate(current + (dx < 0 ? 1 : -1));
      });
      mainWrap.addEventListener('pointercancel', () => { startX = null; });
      mainWrap.addEventListener('dragstart', (e) => e.preventDefault());
    }

    gallery.galleryShowMedia = (mediaId) => {
      const idx = thumbs.findIndex((t) => t.getAttribute('data-media-id') === String(mediaId));
      if (idx > -1 && idx !== current) activate(idx);
    };
  });

  /* ---------- Product quantity stepper -------------------------------- */
  document.addEventListener('click', (e) => {
    const stepper = e.target.closest('.product-form__qty');
    if (!stepper) return;
    const input = stepper.querySelector('input');
    let val = parseInt(input.value, 10) || 1;
    if (e.target.closest('[data-qty-up]')) input.value = val + 1;
    if (e.target.closest('[data-qty-down]')) input.value = Math.max(1, val - 1);
  });

  /* ---------- Scroll-in animations ------------------------------------ */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in-view'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.scroll-trigger').forEach((el) => io.observe(el));
  }

  /* ---------- Sticky header (group wrapper) + scroll state ------------ */
  var headerEl = document.querySelector('.header');
  if (headerEl) {
    var sectionWrap = headerEl.closest('.shopify-section');
    var groupEl = sectionWrap ? sectionWrap.parentElement : null;
    if (groupEl) groupEl.classList.add('pulse-header-group');

    var darkHero = document.querySelector('[data-reveal]');
    var onHeaderScroll = function () {
      headerEl.classList.toggle('header--scrolled', window.scrollY > 40);
      if (darkHero) {
        var rect = darkHero.getBoundingClientRect();
        var navBottom = headerEl.getBoundingClientRect().bottom;
        headerEl.classList.toggle('header--over-dark', rect.top < navBottom && rect.bottom > 0);
      }
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    window.addEventListener('resize', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  /* ---------- Initial cart paint -------------------------------------- */
  refreshCart(false);
})();
